import React from 'react';
import Dansaar from './dansaar';

const PageList = () => <Dansaar />;

export default PageList;
